import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import React from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import navigation from '../../../../lib/navigation/navigation';
import RightArrowIcon from '../../../icons/arrow-icon/RightArrowIcon';
import CmsContent from '../../CmsContent';
import styles from './BinaryWrapper.less';

function handleNavigation(link) {
  navigation({
    navigationUrl: link,
    displayType: 'pdf'
  });
}

export var BinaryWrapper = function BinaryWrapper(_ref) {
  var data = _ref.data;

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var title = _ref2$component.title,
      _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var asset = _ref2$component$conte.asset;
  return asset && Array.isArray(asset) && asset.length ? /*#__PURE__*/React.createElement(React.Fragment, null, asset.map(function (link, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement("button", {
      "data-testid": "asset-link-button",
      onClick: function onClick() {
        handleNavigation(link);
      }
    }, /*#__PURE__*/React.createElement(Block, {
      el: "span",
      layout: true,
      justifyBetween: true,
      center: true,
      className: styles['link-wrapper']
    }, /*#__PURE__*/React.createElement(CmsContent, {
      content: title
    }), /*#__PURE__*/React.createElement("span", {
      className: styles['link-arrow']
    }, /*#__PURE__*/React.createElement(RightArrowIcon, null)))));
  })) : null;
};
BinaryWrapper.propTypes = {
  data: PropTypes.object.isRequired
};
export default BinaryWrapper;